export default __webpack_public_path__ + "static/media/resume.f184a744.pdf";